module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/price-familia-f1781ceda4fde46e1573ccc85d865c41.svg";